import { useContext, useEffect, useState } from 'react'
import { useRafLoop } from 'react-use'
import { Range } from 'types'
import { PlayheadWithoutContext } from '../../playhead'
import { UGEContext } from '../context'

type Props = {
    className?: string
    trim: Range
}

const UGETrimmerPlayhead = ({ className, trim }: Props) => {
    const { getProgress } = useContext(UGEContext)
    const [progress, setProgress] = useState<number>(0)
    const duration = trim.end - trim.start
    const trimmedProgress = progress - trim.start

    const [stopLoop, startLoop] = useRafLoop(() => {
        setProgress(getProgress())
    }, false)

    useEffect(() => {
        startLoop()

        return () => {
            stopLoop()
        }
    }, [])

    return <PlayheadWithoutContext className={className} duration={duration} scrubbable time={trimmedProgress} />
}

export default UGETrimmerPlayhead
